var _g, _g2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAsk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.3,
    height: 24.91,
    viewBox: "0 0 20.3 24.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "user-ask"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,10.3a3.1,3.1,0,1,1,3.1,3.1A3.12,3.12,0,0,1,8.5,10.3Zm.8,0A2.3,2.3,0,1,0,11.6,8,2.39,2.39,0,0,0,9.3,10.3Z",
    transform: "translate(-1.7 1.11)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,19.4c0-1.8-1.9-3.3-4.2-3.3s-4.2,1.5-4.2,3.3a.4.4,0,0,1-.8,0c0-2.3,2.2-4.1,5-4.1s5,1.9,5,4.1a.4.4,0,0,1-.8,0Z",
    transform: "translate(-1.7 1.11)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_26",
    "data-name": "Capa 26"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1, 0.04, -0.04, 1, 12.65, 9.47)",
    fontSize: 11,
    fill: "{props.color}",
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "?"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1, 0.04, -0.04, 1, 12.65, 9.47)",
    fontSize: 11,
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "?")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_28",
    "data-name": "Capa 28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7,7.4a.94.94,0,0,0-.2,1.1,9.54,9.54,0,0,1,1.8,5.1,8.55,8.55,0,0,1-17.1.1,8.64,8.64,0,0,1,8.5-8.6,13.66,13.66,0,0,1,1.9.2H14c.1,0,.1,0,.2-.1a.1.1,0,0,0,.1-.1h0a.1.1,0,0,1,.1-.1l.1-.1a.1.1,0,0,1,.1-.1V4.3a.1.1,0,0,0-.1-.1c0-.1,0-.1-.1-.1h0L14.3,4c-.3-.1-.6-.2-1-.3a.37.37,0,0,1-.3-.1H11.6A10,10,0,0,0,1.7,13.7,10.15,10.15,0,1,0,22,13.6a9.34,9.34,0,0,0-2.1-6A.93.93,0,0,0,18.7,7.4Z",
    transform: "translate(-1.7 1.11)",
    fill: "{props.color}"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.7 1.11)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1.7 1.11)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAsk);
export default __webpack_public_path__ + "static/media/user-ask.de939918ca10da67d59cdb0039926dd4.svg";
export { ForwardRef as ReactComponent };